<header class="page-head" *ngIf="!customer_success" data-testid="partner-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-handshake-o"></i></span>
    <div>
      <h1 class="page-head__title">Parceiros</h1>
      <p class="page-head__subtitle">Seus ganhos com indicações e o saldo das contas que você gerencia.</p>
    </div>
  </div>
  <div class="page-head__actions">
    <a class="sf-btn sf-btn--secondary" routerLink="/partner/payments">
      <i class="fa fa-money"></i> Pagamentos
    </a>
    <a class="sf-btn sf-btn--secondary" routerLink="/api" *ngIf="isApiEnabled">
      <i class="fa fa-plug"></i> API
    </a>
  </div>
</header>

<div class="alert alert-danger" *ngIf="!user.pix_key && !customer_success && isAccountOwner" data-testid="pix-missing-notice">
  <i class="fa fa-exclamation-triangle"></i>
  <div style="flex:1">
    <strong>Cadastre sua chave pix</strong> para receber os pagamentos das comissões.
  </div>
  <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="showPixForm()">
    <i class="fa fa-plus"></i> Cadastrar chave pix
  </button>
</div>

<div *ngIf="!customer_success" class="dashboard">
  <app-skeleton *ngIf="loadingPartnerInfo" variant="card" [count]="3"
    label="Carregando o resumo de parceiro" data-testid="partner-info-loading"></app-skeleton>

  <div *ngIf="partnerInfo$ | async as partnerInfo">
    <div class="kpi-row">
      <div class="sf-card earnings-card">
        <div class="section-title"><i class="fa fa-calendar-o"></i> Seus ganhos</div>
        <p class="field-hint">Mês anterior</p>
        <h3>
          <span class="symbol">R$</span>
          {{ partnerInfo.lastPayment?.amount | numberFormat : "" : true : 2 }}
        </h3>
        <div class="status" *ngIf="partnerInfo.lastPayment">
          <b>STATUS:</b> {{ partnerInfo.lastPayment.status | paymentStatus }}
        </div>
      </div>

      <div class="sf-card earnings-card">
        <div class="section-title">
          <i class="fa fa-clock-o"></i> Seus ganhos
          <i class="fa fa-question-circle ms-2" ngbTooltip="Seus ganhos são calculados sobre as recargas realizadas pelos seus parceiros"></i>
        </div>
        <p class="field-hint">Mês atual</p>
        <h3>
          <span class="symbol">R$</span>
          {{ partnerInfo.actualPayment?.amount | numberFormat : "" : true : 2 }}
        </h3>
        <div class="status" *ngIf="partnerInfo.actualPayment">
          <b>STATUS:</b> {{ partnerInfo.actualPayment.status | paymentStatus }}
        </div>
      </div>

      <div class="sf-card earnings-card featured">
        <div class="section-title"><i class="fa fa-money"></i> Seus ganhos</div>
        <p class="field-hint">Totais · até o último depósito</p>
        <h3>
          <span class="symbol">R$</span>
          {{ partnerInfo.totalPaid | numberFormat : "" : true : 2 }}
        </h3>
        <a class="sf-btn sf-btn--secondary sf-btn--sm foot-act" routerLink="/partner/payments">
          <i class="fa fa-line-chart"></i> Relatório
        </a>
      </div>
    </div>

    <div class="info-row">
      <div class="sf-card">
        <div class="section-title">
          <i class="fa fa-user"></i> Meus dados
          <span class="right" *ngIf="isAccountOwner" data-testid="partner-pix-actions">
            <a class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" (click)="showPixForm()"
              ngbTooltip="{{ user.pix_key ? 'Alterar' : 'Cadastrar' }} chave pix">
              <i class="fa" [ngClass]="{ 'fa-plus': !user.pix_key, 'fa-pencil': user.pix_key }"></i>
            </a>
            <a class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" (click)="deletePixKey()" *ngIf="user.pix_key" data-testid="btn-delete-pix"
              ngbTooltip="Excluir chave pix">
              <i class="fa fa-trash"></i>
            </a>
          </span>
        </div>
        <div class="def-grid">
          <div class="def"><dt>Nome</dt><dd>{{ user.name }}</dd></div>
          <div class="def"><dt>Chave pix</dt><dd [class.text-muted]="!user.pix_key">{{ user.pix_key ?? "— não cadastrada" }}</dd></div>
          <div class="def"><dt>E-mail</dt><dd>{{ user.email }}</dd></div>
        </div>
      </div>

      <div class="sf-card">
        <div class="section-title"><i class="fa fa-link"></i> URL de indicação</div>
        <div class="field">
          <label>URL paga</label>
          <div class="input-group">
            <input type="text" class="form-control" readonly [value]="user.affiliation?.short_paid_url" />
            <button type="button" class="sf-btn sf-btn--primary sf-btn--icon" aria-label="Copiar link"
              (click)="copy(user.affiliation?.short_paid_url)" ngbTooltip="Clique aqui para copiar">
              <i class="fa fa-copy"></i>
            </button>
          </div>
        </div>
        <div class="field">
          <label>URL gratuita</label>
          <div class="input-group">
            <input type="text" class="form-control" readonly [value]="user.affiliation?.short_free_url" />
            <button type="button" class="sf-btn sf-btn--primary sf-btn--icon" aria-label="Copiar link"
              (click)="copy(user.affiliation?.short_free_url)" ngbTooltip="Clique aqui para copiar">
              <i class="fa fa-copy"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="sf-card">
        <div class="section-title"><i class="fa fa-bar-chart"></i> Relatório de indicação</div>
        <div class="def-grid">
          <div class="def"><dt>Mês atual</dt><dd>{{ partnerInfo.actualIndications | numberFormat }}</dd></div>
          <div class="def"><dt>Mês passado</dt><dd>{{ partnerInfo.lastIndications | numberFormat }}</dd></div>
          <div class="def"><dt>Total</dt><dd>{{ partnerInfo.totalIndications | numberFormat }}</dd></div>
        </div>
      </div>
    </div>
  </div>

  <app-skeleton *ngIf="loadingAffiliates" variant="table-row" [count]="6" [columns]="4"
    label="Carregando os afiliados" data-testid="affiliates-loading"></app-skeleton>

  <div class="sf-card empty" *ngIf="affiliatesError && !loadingAffiliates" data-testid="affiliates-error">
    <i class="fa fa-exclamation-triangle"></i>
    <p><strong>Não foi possível carregar as contas</strong></p>
    <p class="field-hint" *ngIf="affiliatesError === 'offline'">O servidor não respondeu. Confira a sua conexão e tente de novo.</p>
    <p class="field-hint" *ngIf="affiliatesError === 'server'">Tente de novo em instantes. Se continuar, fale com o suporte.</p>
    <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="listPaginated()" data-testid="btn-retry-affiliates">
      <i class="fa fa-refresh"></i> Tentar de novo
    </button>
  </div>

  <div *ngIf="affiliates$ | async as affiliates" class="sf-card accounts-card">
    <div class="section-bar">
      <h2><i class="fa fa-users"></i> Contas gerenciadas</h2>
      <div class="sf-btn-group">
        <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="active" (click)="showActives()" data-testid="btn-tab-active">
          Ativos <span class="cnt">{{ affiliates.counts?.active }}</span>
        </button>
        <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="!active" (click)="showInactives()" data-testid="btn-tab-inactive">
          Inativos <span class="cnt">{{ affiliates.counts?.inactive }}</span>
        </button>
      </div>
    </div>

    <div class="filter-bar">
      <div class="search-wrap grow">
        <i class="fa fa-search"></i>
        <input type="text" name="filter" class="form-control" placeholder="Pesquisar pelo nome ou e-mail"
          [(ngModel)]="filter" (keydown.enter)="pageChanged(1)" data-testid="input-search-affiliate" />
        <button type="button" class="search-go" aria-label="Pesquisar" (click)="pageChanged(1)">
          <i class="fa fa-search"></i>
        </button>
      </div>
      <div class="sort-wrap">
        <select name="sort" class="form-select" [ngModel]="sortSelectValue" (ngModelChange)="sortChanged($event)" data-testid="select-sort">
          <option value="name|asc">Nome A→Z</option>
          <option value="name|desc">Nome Z→A</option>
          <option value="balance|asc">Saldo: menor primeiro</option>
          <option value="balance|desc">Saldo: maior primeiro</option>
        </select>
      </div>
    </div>

    <div class="chips-bar">
      <span class="lbl-sm">Tipo</span>
      <button type="button" class="chip" [class.on]="type === 'all'" (click)="setType('all')">Todas</button>
      <button type="button" class="chip" [class.on]="type === 'wallet'" (click)="setType('wallet')">
        <i class="fa fa-money"></i> Carteira
      </button>
      <button type="button" class="chip" [class.on]="type === 'credits'" (click)="setType('credits')">
        <i class="fa fa-layer-group"></i> Créditos
      </button>
      <button type="button" class="chip chip--warm" [class.on]="low" (click)="toggleLow()" data-testid="chip-low-balance">
        <i class="fa fa-exclamation-triangle"></i> Saldo baixo
        <ng-container *ngIf="affiliates.counts?.low !== null">({{ affiliates.counts?.low }})</ng-container>
      </button>
    </div>

    <div class="alert alert-warning" *ngIf="affiliates.wallet_unavailable" data-testid="wallet-unavailable-notice">
      <i class="fa fa-exclamation-triangle"></i>
      <div style="flex:1">
        <strong>A carteira não respondeu agora.</strong> Contas do tipo Carteira aparecem como "Saldo indisponível" — não é saldo zero.
        Os créditos do pacote continuam certos.
      </div>
    </div>

    <div class="alert alert-warning" *ngIf="affiliates.limited" data-testid="balance-limited-notice">
      <i class="fa fa-exclamation-triangle"></i>
      <div style="flex:1">
        São muitas contas migradas para ordenar por saldo ou filtrar por saldo baixo com precisão agora — a lista está ordenada por Nome.
      </div>
    </div>

    <div class="user-list" *ngIf="affiliates.data.length > 0; else notFound">
      <div class="row-card" *ngFor="let account of affiliates.data" [class.is-active]="account.active"
        [class.is-inactive]="!account.active" (click)="openDrawer(account)" data-testid="affiliate-item">
        <span class="row-avatar"><i class="fa fa-user"></i></span>

        <div class="info">
          <div class="name">
            <span class="title" [ngClass]="account.active ? 'primary' : 'danger'">{{ account.name }}</span>
            <span class="type-badge" *ngIf="account.balance_kind" [class.type-badge--credits]="account.balance_kind === 'credits'">
              <i class="fa" [ngClass]="account.balance_kind === 'credits' ? 'fa-layer-group' : 'fa-money'"></i>
              {{ account.balance_kind === 'credits' ? 'Créditos' : 'Carteira' }}
            </span>
          </div>

          <div class="meta-line">
            <span class="meta-chip"><i class="fa fa-envelope-o"></i> {{ account.email }}</span>
            <a *ngIf="account.phone" class="meta-chip" href="https://wa.me/+55{{ account.phone }}" target="_blank"
              (click)="$event.stopPropagation()" ngbTooltip="Enviar mensagem via WhatsApp {{ account.phone }}">
              <i class="fa fa-whatsapp"></i> {{ account.phone }}
            </a>
          </div>

          <app-account-balance [source]="account" mode="cell"></app-account-balance>
        </div>

        <div class="icon-group" (click)="$event.stopPropagation()">
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" *ngIf="isApiEnabled"
            [routerLink]="['/partner/statistics', account.id]">
            <i class="fa fa-bar-chart"></i> Estatísticas
          </button>
          <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" *ngIf="canAccessClientAccount" (click)="simulate(account)">
            <i class="fa fa-external-link"></i> Acessar conta
          </button>
          <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" (click)="copyEmail(account)"
            ngbTooltip="Copiar e-mail">
            <i class="fa fa-copy"></i>
          </button>
        </div>
      </div>
    </div>

    <ng-template #notFound>
      <div class="sf-card empty" data-testid="affiliates-empty">
        <i class="fa fa-search"></i>
        <p *ngIf="filter || type !== 'all' || low">Nenhuma conta encontrada com esse filtro.</p>
        <p *ngIf="!filter && type === 'all' && !low">Nenhum cliente :(</p>
        <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="clearFilters()"
          *ngIf="filter || type !== 'all' || low">
          Limpar filtros
        </button>
      </div>
    </ng-template>

    <div class="list-foot" *ngIf="affiliates.data.length > 0">
      <div class="per">
        Por página
        <select class="form-select" [ngModel]="perPage" (ngModelChange)="pageChanged(1, $event)">
          <option [ngValue]="10">10</option>
          <option [ngValue]="25">25</option>
        </select>
      </div>
      <app-pagination
        look="v2"
        [currentPage]="affiliates.current_page"
        [itemsPerPage]="affiliates.per_page"
        [totalItems]="affiliates.total"
        (pageChanged)="pageChanged($event)"
      ></app-pagination>
    </div>
  </div>

  <app-modal-pix-key
    [showModal]="showModal"
    (modalClosed)="modalClosed($event)"
  ></app-modal-pix-key>

  <app-account-drawer
    *ngIf="drawerAffiliate"
    [account]="drawerAffiliate"
    [canSeeStatistics]="isApiEnabled"
    [canSimulate]="canAccessClientAccount"
    (simulate)="simulate($event)"
    (closed)="closeDrawer()"
  ></app-account-drawer>
</div>
